
// game variables
let accelerationUp = 0.17;
let animShieldMin = -2;
let animShieldMax = 2;
let animShieldInc = 1;
let animShieldValue = 0;
let attackLoaderValue = 0; // 0 to 100
let buttons;
let chargedAttackCooldown = false;
let chatMessages = [];
let corpses = [];
let enemies = [];
let enemiesSpawnedThisWave = 0;
let fireStartedAt = null;
let interactionEnabled = true;
let items = [];
let lastFireAt = null;
let leftIsPressed = false;
let lives = 3;
let loop = 0;
let killCount = 0;
let mana = 100;
let maxLives = 3;
const keyHaveBeenPressedOnce = { // used to display hints
  up: false,
  left: false,
  right: false,
  f: false,
  r: false
};
let shots = [];
let particleEffects = [];
let playerX = GAME_WIDTH / 3;
let playerY = GAME_HEIGHT / 2 + 150;
let recoilAcceleration = 0.2;
let recoilSpeed = 0; // recoil movement after being hit
let restCountdown = 0;
let rightIsPressed = false;
let playerDirection = DIRECTION.RIGHT;
let playerIsPoweredUp = false; // gives double shot
let playerIsEvocating = false; // player is not able to move while evocating
let randomTip = RANDOM_TIPS[Math.floor(Math.random() * RANDOM_TIPS.length)];
let skeletons = [];
let skeletonsRaised = 0;
let speedUp = 0;
const stars = [];
let state = STATES.TITLE;
let waveNumber = 1;

// global time-based checks
let manaLastCheck = Date.now();
let restCountdownLastCheck = Date.now();
let animationLastCheck = Date.now();
let loaderLastCheck = Date.now();
